import { useMemo } from 'react'

import { useEffectiveConfig } from './useEffectiveConfig'
import { stripToText } from './util'

export const decorateEmailWithCompliance = (body: string, complianceText: string | null, separator = '\n\n') => {
  if (complianceText) {
    return `${stripToText(body)}${separator}${complianceText}\n\n`
  }
  return body
}

export const useMailtoDecorateWithCompliance = (body: string) => {
  const { emailComplianceMessage } = useEffectiveConfig()

  return useMemo(() => {
    if (emailComplianceMessage && body) {
      return decorateEmailWithCompliance(body, emailComplianceMessage)
    }
    return body
  }, [body, emailComplianceMessage])
}
